module.exports = __webpack_public_path__ + "img/right-arrow.cd052008.svg";